import React, { useState, useEffect } from "react";
import "../user_styles/secureNumberPad.css";
import { useLanguage } from "../i18n/LanguageContext";

// 항상 일관된 키패드 배치 (1~9 후 0, 일반 전화기와 동일)
const FIXED_KEYS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

export default function SecureNumberPad({ visible, onConfirm, onCancel }) {
    const { t } = useLanguage();
    const [digits, setDigits] = useState("");
    const shuffledKeys = FIXED_KEYS;

    useEffect(() => {
        if (visible) {
            setDigits("");
        }
    }, [visible]);

    const handleDigitPress = (digit) => {
        if (digits.length < 10) {
            setDigits((prev) => prev + String(digit));
        }
    };

    const handleBackspace = () => {
        setDigits((prev) => prev.slice(0, -1));
    };

    const handleConfirm = () => {
        if (digits.length === 10) {
            onConfirm(digits);
        }
    };

    if (!visible) return null;

    const digitBoxes = [];
    for (let i = 0; i < 10; i++) {
        digitBoxes.push(
            <div
                key={`digit-${i}`}
                className={`snp-digit-box ${i < digits.length ? "filled" : ""}`}
            >
                <span className="snp-digit-text">
                    {i < digits.length ? digits[i] : ""}
                </span>
            </div>
        );
    }

    return (
        <div className="snp-overlay">
            <div className="snp-container">
                <div className="snp-header">
                    <i className="fas fa-lock snp-lock-icon"></i>
                    <div className="snp-title">{t("keypad.title")}</div>
                    <div className="snp-subtitle">{t("keypad.subtitle")}</div>
                </div>

                <div className="snp-display">
                    <div className="snp-digit-row">{digitBoxes}</div>
                    <div className="snp-format-hint">
                        {digits.length > 0 ? digits : t("keypad.placeholder")}
                    </div>
                </div>

                <div className="snp-keypad">
                    {shuffledKeys.slice(0, 9).map((digit, index) => (
                        <button
                            key={`key-${index}`}
                            className="snp-key"
                            onClick={() => handleDigitPress(digit)}
                            type="button"
                        >
                            {digit}
                        </button>
                    ))}

                    <button
                        className="snp-key snp-cancel-key"
                        onClick={onCancel}
                        type="button"
                    >
                        {t("bizform.cancel")}
                    </button>

                    <button
                        className="snp-key"
                        onClick={() => handleDigitPress(shuffledKeys[9])}
                        type="button"
                    >
                        {shuffledKeys[9]}
                    </button>

                    <button
                        className="snp-key snp-backspace-key"
                        onClick={handleBackspace}
                        type="button"
                    >
                        <i className="fas fa-backspace"></i>
                    </button>
                </div>

                <button
                    className={`snp-confirm ${digits.length === 10 ? "active" : ""}`}
                    onClick={handleConfirm}
                    disabled={digits.length !== 10}
                    type="button"
                >
                    {t("bizform.confirm")} ({digits.length}/10)
                </button>
            </div>
        </div>
    );
}
